module.exports = __webpack_public_path__ + "assets/login-frontend/id_upside_down-ef9dcc3a91c783c0.png";